// extracted by mini-css-extract-plugin
module.exports =  {"menu-container":"bDvcGWC","menuContainer":"bDvcGWC"};